import React, { useState } from "react";
import { Alert, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { setDesig_LevelList, setDesig_LevelMessage } from "redux/actions";
import { RootState } from "redux/reducers";
import { useAppDispatch } from "redux/store";
import { getDesig_Level } from "services/desig_levelService";
import Layout from "template";
import { Constant } from "template/Constant";
import { Desig_LevelForm } from "./form";
import { Desig_LevelTable } from "./table";

export const Desig_Level: React.FC = () => {
  const dispatch = useAppDispatch();
  const rData = useSelector((state: RootState) => state.desig_level);
  const [row, setRow] = useState(undefined);
  const [action, setAction] = useState('');
  const getData = (page, pageSize, searchKey) => {
    getDesig_Level(page, pageSize, searchKey).then((response) => {
      if (response && response.records) {
        dispatch(setDesig_LevelList({ pageNo: page, pageSize: pageSize, list: response.records, totalCount: response.totalCount, searchKey: searchKey }));
      } else {
		dispatch(setDesig_LevelMessage("No Record Found"));
      }
    })
  }

  const handleRowEdit = (rowData) => {
    setRow(rowData);
    dispatch(setDesig_LevelMessage(''));
    setAction('edit');
  }
  return (
    <Layout>
      <div className="container-fluid">
        {/* <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <h1 className="h3 mb-0 text-gray-800">Desig_Level</h1>
        </div> */}
        <div className="d-flex flex-column min-vh-100">
          {rData.message ?
            <Alert variant={Constant.defaultAlertVarient} className="alert-dismissible fade">{rData.message}
              <Button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={() => dispatch(setDesig_LevelMessage(''))}>
                <span aria-hidden="true">&times;</span>
              </Button>
            </Alert> : null}
          {action ? <Desig_LevelForm hideShowForm={setAction} action={action} row={row} getData={getData} /> :
            <Desig_LevelTable handleRowEdit={handleRowEdit} hideShowForm={setAction} getData={getData} />}
        </div>

      </div>
    </Layout >
  );
};

